<cst-card>
  <ng-template cstCardContent>
    @for (i of internalValues; track i; let j = $index) {
      <div class="input">
        <tab-formular-input-control
          [inputFormGroup]="form"
          [inputFormGroupName]="formularGroupDataKey"
          [inputControl]="getCtl(j)"
          [inputLabel]="i['Label']"
          [htmlType]="inputTypeToHtmlType(getInputString(i['Type']))"
        >
        </tab-formular-input-control>
        <!-- <ng-container
          *ngTemplateOutlet="dynamicInput; context: { inpt: i, index: j }"
        >
        </ng-container> -->
      </div>
    }
  </ng-template>
</cst-card>

<!-- <ng-template #dynamicInput let-inpt="inpt" let-index="index"> </ng-template>

<ng-template #chkBoxInput let-inpt="inpt" let-index="index">
  <form [formGroup]="form">
    <div formGroupName="{{ formularGroupDataKey }}"></div>
    <frm-check
      [formControl]="getCtl(index)"
      [label]="inpt['Label']"
    ></frm-check>
  </form>
</ng-template>

<ng-template #textInput let-inpt="inpt" let-index="index">
  <form [formGroup]="form">
    <div formGroupName="{{ formularGroupDataKey }}">
      <frm-text
        [label]="inpt['Label']"
        [formControl]="getCtl(index)"
      ></frm-text>
    </div>
  </form>
</ng-template>

<ng-template #textAreaInput let-inpt="inpt" let-index="index">
  <form [formGroup]="form">
    <div formGroupName="{{ formularGroupDataKey }}">
      <frm-text
        [label]="inpt['Label']"
        [formControl]="getCtl(index)"
        [multiline]="true"
        [rows]="16"
      ></frm-text>
    </div>
  </form>
</ng-template>

<ng-template #datePicker let-inpt="inpt" let-index="index">
  <form [formGroup]="form">
    <div formGroupName="{{ formularGroupDataKey }}">
      <frm-date-picker
        label="{{ inpt['Label'] }}"
        format="dd.MM.yyyy"
        [formControl]="getCtl(index)"
      ></frm-date-picker>
    </div>
  </form>
</ng-template>

<ng-template #dateTimePicker let-inpt="inpt" let-index="index">
  <form [formGroup]="form">
    <div formGroupName="{{ formularGroupDataKey }}">
      <frm-date-picker
        label="{{ inpt['Label'] }}"
        format="dd.MM.yyyy"
        [formControl]="getCtl(index)"
      ></frm-date-picker>
    </div>
  </form>
</ng-template>

<ng-template #timePicker let-inpt="inpt" let-index="index">
  <form [formGroup]="form">
    <div formGroupName="{{ formularGroupDataKey }}">
      <frm-time-picker
        [formControl]="getCtl(index)"
        [label]="inpt['Label']"
        mode="timeSpan"
      ></frm-time-picker>
    </div>
  </form>
</ng-template> -->
